import { IFormErrors } from '@interfaces/IFormsErrors';
import { INote } from '@interfaces/INoteData';
import { IWorkDebtorsQParams } from '@interfaces/IQParams';
import { IWorkDebtors, IWorkDebtorsData } from '@interfaces/IWorkDebtors';
import { Action } from '@ngrx/store';

export enum EWorkDebtorsActions {
  GetWorkDebtorsRequest = '[Work debtors] Get Work Debtors Request',
  GetWorkDebtorsSuccess = '[Work debtors] Get Work Debtors Success',
  GetWorkDebtorsFailure = '[Work debtors] Get Work Debtors Failure',
  ClearWorkDebtors = '[Work debtors] Clear Work Debtors',

  GetWorkDebtorsByGroupRequest = '[Work debtors] Get Work Debtors By Group Request',
  GetWorkDebtorsByGroupSuccess = '[Work debtors] Get Work Debtors By Group Success',
  GetWorkDebtorsByGroupFailure = '[Work debtors] Get Work Debtors By Group Failure',
  ClearGetWorkDebtorsByGroup = '[Work debtors] Clear Get Work Debtors By Group',

  AddWorkDebtorsRequest = '[Work debtors] Add Work Debtors Request',
  AddWorkDebtorsSuccess = '[Work debtors] Add Work Debtors Success',
  AddWorkDebtorsFailure = '[Work debtors] Add Work Debtors Failure',
  ClearAddWorkDebtorsErrors = '[Work debtors] Clear Add Work Debtors Errors',
}

export class GetWorkDebtorsRequest implements Action {
  public readonly type = EWorkDebtorsActions.GetWorkDebtorsRequest;

  constructor(public qParams: IWorkDebtorsQParams) {}
}

export class GetWorkDebtorsSuccess implements Action {
  public readonly type = EWorkDebtorsActions.GetWorkDebtorsSuccess;

  constructor(public payload: INote[]) {}
}

export class GetWorkDebtorsFailure implements Action {
  public readonly type = EWorkDebtorsActions.GetWorkDebtorsFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetWorkDebtors implements Action {
  public readonly type = EWorkDebtorsActions.ClearWorkDebtors;
}

export class GetWorkDebtorsByGroupRequest implements Action {
  public readonly type = EWorkDebtorsActions.GetWorkDebtorsByGroupRequest;

  constructor(public groupId: number, public qParams: IWorkDebtorsQParams) {}
}

export class GetWorkDebtorsByGroupSuccess implements Action {
  public readonly type = EWorkDebtorsActions.GetWorkDebtorsByGroupSuccess;

  constructor(public payload: IWorkDebtors) {}
}

export class GetWorkDebtorsByGroupFailure implements Action {
  public readonly type = EWorkDebtorsActions.GetWorkDebtorsByGroupFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetWorkDebtorsByGroup implements Action {
  public readonly type = EWorkDebtorsActions.ClearGetWorkDebtorsByGroup;
}

export class AddWorkDebtorsRequest implements Action {
  public readonly type = EWorkDebtorsActions.AddWorkDebtorsRequest;

  constructor(public data: IWorkDebtorsData) {}
}

export class AddWorkDebtorsSuccess implements Action {
  public readonly type = EWorkDebtorsActions.AddWorkDebtorsSuccess;
}

export class AddWorkDebtorsFailure implements Action {
  public readonly type = EWorkDebtorsActions.AddWorkDebtorsFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearAddWorkDebtorsErrors implements Action {
  public readonly type = EWorkDebtorsActions.ClearAddWorkDebtorsErrors;
}

export type WorkDebtorsActions =
  | GetWorkDebtorsRequest
  | GetWorkDebtorsSuccess
  | GetWorkDebtorsFailure
  | ClearGetWorkDebtors
  | GetWorkDebtorsByGroupRequest
  | GetWorkDebtorsByGroupSuccess
  | GetWorkDebtorsByGroupFailure
  | ClearGetWorkDebtorsByGroup
  | AddWorkDebtorsRequest
  | AddWorkDebtorsSuccess
  | AddWorkDebtorsFailure
  | ClearAddWorkDebtorsErrors;
